import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const strongAuthenticationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/strong_authentication',
  validateSearch: z.object({
    sso_proof_token: z.string().optional(),
  }),
}).lazy(() =>
  import('pages/shared/StrongAuthentication/StrongAuthenticationPage').then((d) => d.Route)
);
